import { render, staticRenderFns } from "./BarAttendanceFrequency.vue?vue&type=template&id=7fedfbb3"
import script from "./BarAttendanceFrequency.vue?vue&type=script&lang=js"
export * from "./BarAttendanceFrequency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBar from 'quasar/src/components/bar/QBar.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBar});
